(() => {
  if (window.yoriaReviewImageSyncInitialized) return;
  window.yoriaReviewImageSyncInitialized = true;

  const syncProductImage = () => {
    const source = document.querySelector('[data-yoria-review-product]');
    const imageUrl = source?.dataset.yoriaReviewImage;
    if (!imageUrl) return false;

    const productTitle = source.dataset.yoriaReviewTitle || '';
    const modalImages = document.querySelectorAll(
      '.jdgm-review-widget-modal .jdgm-write-review-modal__product-image img'
    );

    modalImages.forEach((image) => {
      if (image.getAttribute('src') !== imageUrl) image.setAttribute('src', imageUrl);
      image.removeAttribute('srcset');
      if (productTitle) image.setAttribute('alt', productTitle);
    });

    return modalImages.length > 0;
  };

  let observer;
  let stopTimer;

  const watchForModal = () => {
    window.clearTimeout(stopTimer);
    observer?.disconnect();

    syncProductImage();

    observer = new MutationObserver(syncProductImage);
    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['src', 'srcset'],
      childList: true,
      subtree: true
    });
    stopTimer = window.setTimeout(() => observer.disconnect(), 10000);
  };

  document.addEventListener('click', (event) => {
    if (event.target instanceof Element && event.target.closest('#judgeme_product_reviews')) {
      watchForModal();
    }
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchForModal, { once: true });
  } else {
    watchForModal();
  }
})();
